import classnames from 'classnames';
import styles from 'components/common/LogicDivider/index.less';
import React, { useState } from 'react';

import LogicSelector from '@components/common/LogicSelector';
import type { ILogicSelector, TLogicOperator } from '@components/common/LogicSelector/typed';
import { Icon } from '@components/metrics-builder/components/MetricList';
import DeleteActiveSvg from '@icons/mapping-panel/delete-active-icon.svg';
import DeleteSvg from '@icons/mapping-panel/delete-icon.svg';

interface ILogicDivider extends ILogicSelector {
  onDelete?: (value: TLogicOperator) => void;
}

const LogicDivider: React.FC<ILogicDivider> = (props) => {
  const { disabled, active, onDelete } = props;

  const [isHover, setHover] = useState<boolean>(false);

  const onMouseOver = () => {
    !disabled && setHover(true);
  };

  const onMouseLeave = () => {
    !disabled && setHover(false);
  };

  const handleDeleteClick = (value) => {
    !disabled && onDelete?.(value);
  };

  return (
    <div
      className={classnames(styles.logicDivider, { [styles.logicDividerActive]: active })}
      onMouseOver={onMouseOver}
      onMouseLeave={onMouseLeave}
      onClick={(e) => e.stopPropagation()}
    >
      <div className={styles.logicDividerLine} />
      <div className={styles.logicDividerOperator}>
        <LogicSelector disabled={disabled} active={isHover} {...props} />
      </div>
      <div className={classnames(styles.logicDividerLine, styles.logicDividerFlex)} />
      <div className={styles.logicDividerDelete}>
        {!disabled && (
          <Icon
            component={DeleteSvg}
            activeComponent={DeleteActiveSvg}
            onClick={handleDeleteClick}
          />
        )}
      </div>
    </div>
  );
};

export default LogicDivider;
